module.exports = __webpack_public_path__ + "img/dialog_alert.77854603.svg";